





import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EventBus } from "@/EventBus.ts";
import { Action, Getter } from "vuex-class";
import { ThemeConfig } from "../plugins/config";

@Component({
  name: "app-themes",
})
export default class AppThemes extends Vue {
  private show = false;

  @Action("setCurrentTheme")
  public setCurrentTheme!: (theme: ThemeConfig) => Promise<void>;

  @Getter("theme")
  public theme!: ThemeConfig;

  get currentTheme() {
    return () => import(`./${this.theme.component}`);
  }

  public loaded() {
    this.show = true;
  }

  private setTitle(title: string) {
    const slug = window.document.title;
    window.document.title = `${slug} ${title}`;
  }

  private setFavicon(img: string) {
    let favicon = document.querySelector('link[rel="shortcut icon"]');

    if (!favicon) {
      favicon = document.createElement("link");
      favicon.setAttribute("rel", "shortcut icon");
      const head: any = document.querySelector("head");
      head.appendChild(favicon);
    }

    favicon.setAttribute("type", "image/png");
    favicon.setAttribute("href", img);
  }

  public async beforeMount() {
    const host = window.location.host;
    const theme = this.$AppConfig.Themes[host] || this.$AppConfig.DefaultTheme;
    await this.setCurrentTheme(theme);
    this.setTitle(theme.title);
    this.setFavicon("/themes/" + theme.name + "/favicon.ico");
  }

  public mounted() {
    EventBus.$on("theme:loaded", this.loaded);
  }
}
